// extracted by mini-css-extract-plugin
export default {"toggle-switch-btn-container":"toggleButton_toggle-switch-btn-container__viwjd","active":"toggleButton_active__YjAGv","toggle-switch-btn":"toggleButton_toggle-switch-btn__jIDu0"};